var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-animate"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title d-inline-block"},[_vm._v("存储桶概况")]),_c('div',{ref:"visitChart",staticClass:"content"},[_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"main"},[_c('span')]),_c('div',{staticClass:"text"},[_vm._v("客官请稍后")])])
}]

export { render, staticRenderFns }